export const shipmentPiecesDataGridSx = {
  border: '1px solid #e0e0e0',
  borderRadius: '8px',
  overflow: 'hidden',
  fontFamily:
    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  '& .MuiDataGrid-root': { border: 'none' },
  '& .MuiDataGrid-columnHeaders': {
    backgroundColor: '#f5f5f5',
    borderBottom: '2px solid #e0e0e0',
    fontSize: '14px',
    fontWeight: 600,
    color: '#333',
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    '& .MuiDataGrid-columnHeaderTitle': {
      fontWeight: 600,
      fontSize: '14px',
      color: '#333',
    },
  },
  '& .MuiDataGrid-cell': {
    whiteSpace: 'normal',
    wordWrap: 'break-word',
    lineHeight: '1.5',
    padding: '12px 16px',
    fontSize: '14px',
    color: '#555',
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    borderBottom: '1px solid #f0f0f0',
  },
  '& .MuiDataGrid-row': {
    '&:hover': { backgroundColor: '#f8f9fa', cursor: 'pointer' },
    '&.Mui-selected': {
      backgroundColor: '#e3f2fd',
      '&:hover': { backgroundColor: '#bbdefb' },
    },
  },
  '& .MuiDataGrid-footerContainer': {
    borderTop: '2px solid #e0e0e0',
    backgroundColor: '#fafafa',
    fontSize: '14px',
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  },
  '@media (max-width: 600px)': {
    '& .MuiDataGrid-cell': {
      minHeight: '60px',
      alignItems: 'center',
      padding: '8px',
      fontSize: '13px',
    },
    '& .MuiDataGrid-columnHeaders': { fontSize: '13px' },
  },
};
